import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { pascalCase } from "./lib/pascalCase.js";
const TODOSliceComponent = ({ slice }) => {
  if (typeof process !== "undefined" && process.env.NODE_ENV === "development") {
    const type = "slice_type" in slice ? slice.slice_type : slice.type;
    console.warn(`[SliceZone] Could not find a component for Slice type "${type}"`, slice);
    return /* @__PURE__ */ jsxs("section", { "data-slice-zone-todo-component": "", "data-slice-type": type, children: [
      "Could not find a component for Slice type “",
      type,
      "”"
    ] });
  } else {
    return null;
  }
};
function SliceZone({ slices = [], components = {}, resolver, defaultComponent = TODOSliceComponent, context = {} }) {
  if (process.env.NODE_ENV === "development") {
    if (resolver) {
      console.warn("The `resolver` prop is deprecated. Please replace it with a components map using the `components` prop.");
    }
  }
  const renderedSlices = slices.map((slice, index) => {
    const type = "slice_type" in slice ? slice.slice_type : slice.type;
    let Comp = components[type] || defaultComponent;
    if (resolver) {
      const resolvedComp = resolver({
        slice,
        sliceName: pascalCase(type),
        i: index
      });
      if (resolvedComp) {
        Comp = resolvedComp;
      }
    }
    const key = "id" in slice && slice.id ? slice.id : `${index}-${JSON.stringify(slice)}`;
    if (slice.__mapped) {
      const { __mapped, ...mappedProps } = slice;
      return /* @__PURE__ */ jsx(Comp, { ...mappedProps }, key);
    } else {
      return /* @__PURE__ */ jsx(Comp, { slice, index, slices, context }, key);
    }
  });
  return /* @__PURE__ */ jsx(Fragment, { children: renderedSlices });
}
export {
  SliceZone,
  TODOSliceComponent
};
//# sourceMappingURL=SliceZone.js.map
